import {Lesson} from "./lessons";

export interface Class {
    name: string;
    link: string;
    description: string;
    weeks: Array<number>;
    time?: string;
    buttonLabel: string;
    lesson?: Lesson;
}
export const classes: Array<Class> = [
    {
        name: 'Sacrament Meeting',
        link: 'https://zoom.us/j/98182692374',
        description: 'Click here to open the zoom Webinar. You may have to enter your email address to connect.',
        weeks: [1,2,3,4,5], 
        time: '10:30am - 11:30am',
        buttonLabel: 'Go to Zoom Webinar',
    },
    {
        name: 'Sacrament Meeting',
        link: 'https://zoom.us/j/98182692374',
        description: 'Special Time because Heritage Park Stake Conference.',
        weeks: [],
        time: '12:00pm - 1:00pm',
        buttonLabel: 'Go to Zoom Webinar',
    },
    {
        name: 'Funeral For James Ward',
        link: 'https://zoom.us/j/95954927081?pwd=PLJvjZpSiGbjS5Co6CjxoGk3re2dvH.1',
        description: 'Click here to open the zoom Webinar of the funeral. You may have to enter your email address to connect.',
        weeks: [], 
        time: 'Friday, January 17, 11:00 am',
        buttonLabel: 'Go to Zoom Webinar',
    },
    {
        name: 'Stake Conference Saturday Adult Session',
        link: 'https://zoom.us/j/94331580258',
        description: 'Adults, click here to open the zoom Webinar.',
        weeks: [],
        time: 'Saturday 7:00pm',
        buttonLabel: 'Go to Zoom Webinar',
    },
    {
        name: 'Stake Conference General Session',
        link: 'https://zoom.us/j/96613040312',
        description: 'All ages, click here to open the zoom Webinar.',
        weeks: [], 
        time: 'Sunday 10:00am - 12:00pm',
        buttonLabel: 'Go to Zoom Webinar',
    },
    {
        name: 'Relief Society Activity',
        link: 'https://zoom.us/j/91365663646?pwd=SlUyUXBSY0VQQVB4ZXdKNmVMOGhldz09',
        description: 'Join the activity remotely.',
        weeks: [],
        time: 'Thursday, 9/15 6:30pm - 8:30pm',
        buttonLabel: 'Go to Zoom',
    },
    {
        name: 'Fifth Sunday',
        link: 'https://zoom.us/j/93562986268?pwd=dDArYUhSVzVZN3U5NldsWnlHc2xQUT09',
        description: 'Join the ward class zoom meeting.',
        weeks: [],
        time: '1:10pm',
        buttonLabel: 'Go to Zoom',
    },
    {
        name: 'Relief Society and Elders Quorum',
        link: 'https://zoom.us/j/96564466078?pwd=S3hKTnF3aUlCVTF3SnEyYVJBdTdsZz09',
        description: 'Join the ward zoom meeting, then go to the breakout room for your class.',
        weeks: [],
        time: '1:10pm',
        buttonLabel: 'Go to Zoom',
    },
    {
        name: 'Emotional Resilience and Personal Finance Devotional',
        link: 'https://us02web.zoom.us/j/5889865247',
        description: 'The devotional is to start these classes, which are specially designed to help individuals and families overcome financial challenges or find support amid the emotional struggles of our day.',
        weeks: [],
        time: 'Sunday 6:00pm',
        buttonLabel: 'Join Zoom Webinar',
    },
    {
        name: 'Virtual Christmas Party',
        link: 'https://youtu.be/OzMY8_IUfs8',
        description: 'Watch Christmas greetings from some of your ward friends.',
        weeks: [],
        time: '',
        buttonLabel: 'Watch on YouTube',
    },
    // {
    //     name: 'Tithing Settlement',
    //     link: 'https://taylorsville12thward.youcanbook.me/',
    //     description: 'Sign up for a time to do tithing settlement',
    //     weeks: [1,2,3,4,5],
    //     time: '',
    //     buttonLabel: 'Go To Appointment Site',
    // },
];
